/* Section omponents angular */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/* End section components angular */

/* Section components project */
import { LoginComponent } from "./login.component";
import { LoginService } from "./login.service";
import { AuthService } from '@app/services/auth.service';
import { SharedModule } from '../admin/shared.module';
/* End section components project */


@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule
  ],
  providers: [
    LoginService,
    AuthService
  ]
})
export class LoginModule { }